// import styles from './ProcessContainer.scss';
import { Component } from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import lodash from 'lodash';
import {
    passwordHasBeenSet,
} from 'common/actions/login';

import {
    loadCurrentRegistrationStep,
    completeTaskAction,
} from 'processflow/actions';

import {
    Sign
} from 'processflow/components/actions';

import {
    TrainingVideo,
    // Eula
} from 'processflow/components/fields';

import EulaComponent from './EulaComponent';

import NewUserRegistrationTasks from '../../../common/components/Login/NewUserRegistrationTasks';
import { getAuthCredentials } from '../../../common/util/auth-storage';

class ProcessContainer extends Component {
    constructor(...args) {
        super(...args);
        this.state = { clearingActions: false };
    }

    componentDidMount() {
        this.shouldRedirect(this.props);
        this.props.loadCurrentRegistrationStep();
    }

    shouldRedirect(props) {
        const {
            processComplete,
            replace
        } = props;

        if (processComplete) {
            replace('/');
        }
    }

    componentWillReceiveProps(nextProps) {
        this.shouldRedirect(nextProps);
        this.setState({ clearingActions: true });
    }

    componentDidUpdate() {
        if (this.state.clearingActions) {
            this.setState({ clearingActions: false });
        }

        const { task, passwordHasBeenSet, loadCurrentRegistrationStep } = this.props;
        if (task) {
            const actionName = lodash.get(task, 'step.state.action.name');
            if (actionName === 'Set Password') {
                passwordHasBeenSet().then(() => loadCurrentRegistrationStep());
            }
        }
    }

    buildDataElements() {
        const { task } = this.props;


        const dataFields = lodash.get(task, 'step.state.dataFields', []);
        const content = lodash.get(this.props.task, 'content', '');

        const fields = dataFields.map((field, i) => {
            const fields = {
                'training-content': <TrainingVideo key={i}
                    fileFormat={lodash.get(content, 'training-content.fileFormat')}
                    videoUrl={lodash.get(content, 'training-content.url')} />,
                // 'eula': <Eula key={i} eula={content['eula']} />
                'eula': <EulaComponent />
            };

            return fields[field];
        });

        return fields;
    }

    buildActionElement() {
        if (this.state.clearingActions) {
            return null;
        }
        const { task, baseUrl } = this.props;

        const action = lodash.get(task, 'step.state.action', {});
        const actions = {
            'sign': <Sign baseUrl={baseUrl} onSign={this.handleAction.bind(this)} action={action} />
        };

        return actions[action.type] || null;
    }

    handleAction(data) {
        const { task, completeTaskAction } = this.props;
        const action = lodash.get(task, 'step.state.action', null);
        const taskId = lodash.get(task, 'task.id', null);
        if (lodash.isNil(action) || lodash.isNil(taskId)) {
            throw new Error('Error when completing task step');
        }
        completeTaskAction(taskId, action.id, data);
    }

    buildHeader() {
        const { task } = this.props;
        const header = lodash.get(task, 'step.state.displayName', 'Loading');
        return { header, task };
    }

    render() {
        const dataElements = this.buildDataElements();
        // const actionElements = this.buildActionElement();
        // const { header, task } = this.buildHeader();
        const { header } = this.buildHeader();
        const { accessToken } = getAuthCredentials();

        return (
            <NewUserRegistrationTasks header={header} dataElements={dataElements} email={this.props.email} accessToken={accessToken} handleAction={this.handleAction.bind(this)} />

        // <div className={styles.container} data-cy="ProcessContainer">
        //     { header }
        //     <div className={styles.content}>
        //         <div className={styles.innerContent} data-cy="ProcessContainer-innerContent">
        //             { dataElements }
        //             { actionElements }
        //         </div>
        //     </div>
        // </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            task: lodash.get(state, 'processflow.current', {}),
            baseUrl: lodash.get(state, 'application.config.corsOriginUrl'),
            processComplete: lodash.get(state, 'processflow.complete', false),
            email: lodash.get(state, 'me.email', '')
        };
    }, {
        loadCurrentRegistrationStep,
        completeTaskAction,
        replace,
        passwordHasBeenSet,
    }
)(ProcessContainer);
